import { Controller } from "stimulus"

// #1706: de teksteditor van een mailing. Een bewerkbaar vlak met een
// werkbalk (alinea, koppen, vet, cursief, onderstreept, opsommingen, links,
// afbeeldingen en variabelen). De HTML gaat via een verborgen veld mee met het
// formulier; de server schoont hem op (MailingOpmaak.schoon).
export default class extends Controller {
  static targets = ["inhoud", "veld", "bestand"]
  static values = { uploadUrl: String, linkVraag: String, fout: String }

  connect() {
    try { document.execCommand("defaultParagraphSeparator", false, "p") } catch (e) { /* oudere browsers */ }
    this.synchroniseer = this.synchroniseer.bind(this)
    this.inhoudTarget.addEventListener("input", this.synchroniseer)
    this.formulier = this.element.closest("form")
    this.bijFormdata = (event) => event.formData.set(this.veldTarget.name, this.html())
    this.formulier?.addEventListener("formdata", this.bijFormdata)
    if (this.inhoudTarget.innerHTML.trim() === "") this.inhoudTarget.innerHTML = "<p><br></p>"
  }

  disconnect() {
    this.inhoudTarget.removeEventListener("input", this.synchroniseer)
    this.formulier?.removeEventListener("formdata", this.bijFormdata)
  }

  // Een klik op een knop in de werkbalk mag de selectie in de tekst niet weghalen
  behoudSelectie(event) {
    if (event.target.closest("button")) event.preventDefault()
  }

  html() {
    return this.inhoudTarget.innerHTML
  }

  synchroniseer() {
    this.veldTarget.value = this.html()
  }

  opdracht(event) {
    event.preventDefault()
    this.inhoudTarget.focus()
    document.execCommand(event.currentTarget.dataset.opdracht, false, null)
    this.synchroniseer()
  }

  blok(event) {
    event.preventDefault()
    this.inhoudTarget.focus()
    document.execCommand("formatBlock", false, event.currentTarget.dataset.blok)
    this.synchroniseer()
  }

  link(event) {
    event.preventDefault()
    const adres = window.prompt(this.linkVraagValue, "https://")
    if (!adres || adres === "https://") return
    if (!/^(https?:\/\/|mailto:)/i.test(adres)) return
    this.inhoudTarget.focus()
    const selectie = window.getSelection()
    if (selectie && selectie.toString().length > 0) {
      document.execCommand("createLink", false, adres)
    } else {
      document.execCommand("insertHTML", false, `<a href="${encodeURI(adres)}">${this.escape(adres)}</a>`)
    }
    this.synchroniseer()
  }

  variabele(event) {
    const waarde = event.currentTarget.value
    if (!waarde) return
    this.inhoudTarget.focus()
    document.execCommand("insertText", false, waarde)
    event.currentTarget.value = ""
    this.synchroniseer()
  }

  kiesAfbeelding(event) {
    event.preventDefault()
    this.bewaarSelectie()
    this.bestandTarget.click()
  }

  async uploadAfbeelding() {
    const bestand = this.bestandTarget.files[0]
    if (!bestand) return
    const data = new FormData()
    data.append("bestand", bestand)
    try {
      const antwoord = await fetch(this.uploadUrlValue, {
        method: "POST",
        headers: { "X-CSRF-Token": this.csrf(), Accept: "application/json" },
        body: data,
        credentials: "same-origin"
      })
      const json = await antwoord.json()
      if (!antwoord.ok || !json.url) throw new Error(json.fout || this.foutValue)
      this.herstelSelectie()
      document.execCommand("insertImage", false, json.url)
      this.synchroniseer()
    } catch (fout) {
      window.alert(fout.message || this.foutValue)
    } finally {
      this.bestandTarget.value = ""
    }
  }

  bewaarSelectie() {
    const selectie = window.getSelection()
    if (selectie && selectie.rangeCount > 0 && this.inhoudTarget.contains(selectie.anchorNode)) {
      this.bewaardBereik = selectie.getRangeAt(0).cloneRange()
    }
  }

  herstelSelectie() {
    this.inhoudTarget.focus()
    if (!this.bewaardBereik) return
    const selectie = window.getSelection()
    selectie.removeAllRanges()
    selectie.addRange(this.bewaardBereik)
  }

  csrf() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }

  escape(tekst) {
    const div = document.createElement("div")
    div.textContent = tekst
    return div.innerHTML
  }
}
